import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as campaignAPI from '../../lib/api/campaignapi';
import { takeLatest } from 'redux-saga/effects';

/**
 * API 서버에 Request 하는 Action Type
 * createRequestSaga 함수에서 제공하고 TYPE, SUCCESS, FAIL 3가지 정의만 가능
 */
const [
    REQ_TYPE_LIST_CAMPAIGN,
    REQ_TYPE_LIST_CAMPAIGN_SUCCESS,
    REQ_TYPE_LIST_CAMPAIGN_FAILURE,
] = createRequestActionTypes('campaign/LIST');

const [
    REQ_TYPE_EVENT_DETAIL,
    REQ_TYPE_EVENT_DETAIL_SUCCESS,
    REQ_TYPE_EVENT_DETAIL_FAILURE,
] = createRequestActionTypes('campaign/EVENT_DETAIL');

const [
    REQ_TYPE_LIST_CAMPAIGN_ADD,
    REQ_TYPE_LIST_CAMPAIGN_ADD_SUCCESS,
    REQ_TYPE_LIST_CAMPAIGN_ADD_FAILURE,
] = createRequestActionTypes('campaign/LIST_ADD');

const [
  REQ_TYPE_APPLY_EVENT,
  REQ_TYPE_APPLY_EVENT_SUCCESS,
  REQ_TYPE_APPLY_EVENT_FAILURE
] = createRequestActionTypes('campaign/APPLY_EVENT');
// 컴포넌트에서 사용할 선택된 캠페인 설정 액션
// const SET_BRAND_CATE_ID = 'cate/SET_BRAND_CATE_ID';

const SET_EVENT_MAIN_TAB_INDEX = 'campaign/SET_EVENT_MAIN_TAB_INDEX';
const RESET_APPLY_EVENT = 'campaign/RESET_APPLY_EVENT'

/**
 * 견적서 요청 Action - Container 에서 요청
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const getCampaignListAction = createAction(REQ_TYPE_LIST_CAMPAIGN);
export const getEventDetailAction = createAction(REQ_TYPE_EVENT_DETAIL, (id) => ({ id }));
export const getCampaignListAddAction = createAction(REQ_TYPE_LIST_CAMPAIGN_ADD);
export const setEventMainTabIndexAction = createAction(SET_EVENT_MAIN_TAB_INDEX);
export const applyEventAction = createAction(REQ_TYPE_APPLY_EVENT, (data)=>({data}))
export const resetApplyEventAction = createAction(RESET_APPLY_EVENT);
/**
 * SAGA API 에서 REST API 호출
 */
const listCampaignSaga = createRequestSaga(REQ_TYPE_LIST_CAMPAIGN, campaignAPI.getEventList);
const getEventDetailSaga = createRequestSaga(REQ_TYPE_EVENT_DETAIL, campaignAPI.getEventDetail);
const listCampaignAddSaga = createRequestSaga(REQ_TYPE_LIST_CAMPAIGN_ADD, campaignAPI.getEventList);
const applyEventSaga = createRequestSaga(REQ_TYPE_APPLY_EVENT, campaignAPI.applyEvent);

export function* campaignSaga() {
    yield takeLatest(REQ_TYPE_LIST_CAMPAIGN, listCampaignSaga);
    yield takeLatest(REQ_TYPE_EVENT_DETAIL, getEventDetailSaga);
    yield takeLatest(REQ_TYPE_LIST_CAMPAIGN_ADD, listCampaignAddSaga);
    yield takeLatest(REQ_TYPE_APPLY_EVENT, applyEventSaga);
}

/**
 * Store에 저장될 값
 */
const initialState = {
  status: null,
  campaignList: null,
  eventDetail: null,
  curTabIndex: 0,            //main tab index
  applyEvent: null,
}

const campaignReducer = handleActions(
    {
        [REQ_TYPE_LIST_CAMPAIGN_SUCCESS]: (state, { payload: campaignList }) => {
            return ({
                ...state,
              campaignList,
            })
        },
        [REQ_TYPE_LIST_CAMPAIGN_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_EVENT_DETAIL_SUCCESS]: (state, { payload: eventDetail }) => {
            return ({
                ...state,
              eventDetail,
            })
        },
        [REQ_TYPE_EVENT_DETAIL_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_CAMPAIGN_ADD_SUCCESS]: (state, { payload: campaignList }) => {
            let dataList = state.campaignList.event.concat(campaignList.event);

            let data = Object.assign({}, state.campaignList);
            data.event = [];
            Object.assign(data.event, dataList);


            return ({
                ...state,
              campaignList: data,
            })
        },
        [REQ_TYPE_LIST_CAMPAIGN_ADD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [SET_EVENT_MAIN_TAB_INDEX]: (state, { payload: curTabIndex }) => {
            return ({
                ...state,
                curTabIndex: curTabIndex,
            })
        },
      [REQ_TYPE_APPLY_EVENT_SUCCESS]: (state, { payload }) => {
        return {
          ...state,
          applyEvent: payload
        }

      },
      [REQ_TYPE_APPLY_EVENT_FAILURE]: (state, { payload: error }) => {
          return {
          ...state,
            error
        }
      },
      [RESET_APPLY_EVENT]: (state) => ({
        ...state,
        applyEvent: null
      })
    }
    , initialState);

export default campaignReducer;
